<template>
  <div class="detail-module">
    <div class="box" v-if="list.length !== 0">
      <div class="detail-box">
        <div class="content">{{ content }}</div>
        <div class="list">
          <div class="flex-item">
            <div class="title">序</div>
            <div class="title" v-if="isManager">门店名称</div>
            <div class="title" :class="{'textCenter' : !isManager }">问卷评分</div>
            <div class="title">顾客评价</div>
          </div>
          <div v-for="(item, index) in list" :key="item.id">
            <div class="flex-item">
              <div class="text">{{ index + 1}}</div>
              <div class="text" v-if="isManager">{{ item.storeName || '-' }}</div>
              <div class="text" :class="{'textCenter' : !isManager }">{{ item.score || '-' }}</div>
              <div class="text">{{ item.evaluate || '/' }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="bottom-box flex flex-between flex-y-center">
        <van-icon name="clock-o" class="clock" />
        <div class="flex-1">提醒时间</div>
        <div class="time">{{ remindDateText || '-' }}</div>
      </div>
    </div>
    <div v-else class="flex flex-col flex-y-center">
      <img src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/2022-07-14/null.png" alt=""
        class="empty-icon" />
      <div class="empty-txt">暂无数据～</div>
    </div>
  </div>
</template>
<script>
import request from "@/utils/request";
import { Toast } from 'vant'
export default {
  name: "earlyWarningoToDoDetail",
  data() {
    return {
      type: '', // 1平均分 2满意度
      empNo: '',
      remindDate: '',
      list: [],
      content: '',
      remindDateText: '',
      isManager: false //判断是区经还是主任
    };
  },
  created() {
    // this.type = this.$route.query.type
    this.empNo = this.$route.query.empNo
    this.remindDate = this.$route.query.remindDate
    // 自定义加载图标
    Toast.loading({
        message: '加载中...',
        forbidClick: true,
        duration: 0, // 持续展示 toast
        loadingType: 'spinner',
    });
    this.getDetail()
  },
  methods: {
    // 获取详情
    getDetail() {
      const params = new URLSearchParams({
        // empNo: '950250',
        // remindDate: '2025-06-10'
        empNo: this.empNo,
        remindDate: this.remindDate
      });
      const url = `?${params.toString()}`
      request({
        url: `/todo/alarm/${url}`,
        method: "get",
      })
        .then((res) => {
          Toast.clear();
          this.list = res.data.alarmList || []
          this.content = res.data.content
          this.remindDateText = res.data.remindDate
          this.isManager = res.data.detailType === 1
          this.list.forEach(ele =>{
            if(ele.evaluate && ele.evaluate.includes("不满")){
              ele.evaluate = ele.evaluate
            }else{
              ele.evaluate = ''
            }
          })
        }).catch((error) => {
          Toast({ position: 'top', message: error ?? '' })
        })
    },
  },
};
</script>
<style lang="less" scoped>
::-webkit-scrollbar {
  display: none;
}

.detail-module {
  background-color: #f9fafc;
  height: 100%;
  overflow-y: auto;
  padding: 40px 30px;
}

.box {
  box-shadow: 0px 6px 26px 0px rgba(2, 2, 2, 0.08);
  border-radius: 20px;
}

.detail-box {
  width: 100%;
  background: #ffffff;
  border-radius: 20px;
  margin: 0 auto;
  padding: 30px 20px;

  .content {
    font-size: 28px;
    color: #000c17;
  }
}

.flex-item {
  display: flex;
  align-items: center;
  font-size: 26px;
  margin-top: 20px;

  .title {
    color: #9a9a9a;
    flex: 1;
  }

  .title:nth-child(1) {
    width: 100px;
    text-align: center;
    flex: none;
  }

  .text {
    font-size: 26px;
    color: #000c17;
    // width: calc((100% - 80px)/3);
     flex: 1;
  }

  .text:nth-child(1) {
    width: 100px;
    text-align: center;
    flex: none;
  }
  .textCenter{
    text-align: center;
  }
}

.bottom-box {
  height: 100px;
  border-top: 1px solid #d7d7d7;
  background-color: #fff;
  border-radius: 0 0 20px 20px;
  font-size: 28px;
  color: #35434c;
  padding: 20px 30px;

  .clock {
    font-size: 32px;
    margin-right: 20px;
  }

  .time {
    width: 344px;
    text-align: right;
  }
}

.empty-icon {
  width: 280px;
  height: 280px;
  margin-top: 179px;
}

.empty-txt {
  font-size: 30px;
  color: #a0acb5;
}
</style>